export default "__VITE_ASSET__8aec1033__"